module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "two-col-content row"
  }, [_c('div', {
    ref: "panel-list",
    staticClass: "panels",
    attrs: {
      "id": "panel-list"
    }
  }, [_c('div', {
    staticClass: "row filter-holder"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('div', {
    staticClass: "menu-icon",
    on: {
      "click": _vm.showMenu
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "Vertical",
      "no-data-text": "Vertical",
      "popper-class": "panel-select",
      "filterable": ""
    },
    nativeOn: {
      "keydown": function($event) {
        _vm.selectOption($event)
      }
    },
    model: {
      value: (_vm.selectedCategory1),
      callback: function($$v) {
        _vm.selectedCategory1 = $$v
      },
      expression: "selectedCategory1"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "All",
      "value": "*"
    }
  }, [_vm._v("All")]), _vm._v(" "), _vm._l((_vm.categoryOne), function(category) {
    return (category && category.length > 1) ? _c('el-option', {
      key: category.id,
      attrs: {
        "label": category.charAt(0).toUpperCase() + category.slice(1),
        "value": category
      }
    }, [_vm._v(_vm._s(category.charAt(0).toUpperCase() + category.slice(1)) + "\n          ")]) : _vm._e()
  })], 2), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "Country",
      "no-data-text": "Country",
      "popper-class": "panel-select",
      "filterable": ""
    },
    nativeOn: {
      "keydown": function($event) {
        _vm.selectOption($event)
      }
    },
    model: {
      value: (_vm.selectedCategory2),
      callback: function($$v) {
        _vm.selectedCategory2 = $$v
      },
      expression: "selectedCategory2"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "All",
      "value": "*"
    }
  }, [_vm._v("All")]), _vm._v(" "), _vm._l((_vm.categoryTwo), function(category) {
    return (category && category.length > 1) ? _c('el-option', {
      key: category.id,
      attrs: {
        "label": category.charAt(0).toUpperCase() + category.slice(1),
        "value": category
      }
    }, [_vm._v(_vm._s(category.charAt(0).toUpperCase() + category.slice(1)) + "\n          ")]) : _vm._e()
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "searchbar"
  }, [_c('el-input', {
    class: (_vm.currentView || '').indexOf('rotator') !== -1 && this.$store.state.user.affiliate_id != '0' ? 'mini-search-bar' : '',
    attrs: {
      "placeholder": "Search"
    },
    model: {
      value: (_vm.searchText),
      callback: function($$v) {
        _vm.searchText = $$v
      },
      expression: "searchText"
    }
  }), _vm._v(" "), ((_vm.currentView || '').indexOf('rotator') !== -1 && this.$store.state.user.affiliate_id != '0') ? _c('el-button', {
    staticClass: "new-rotator-btn",
    attrs: {
      "size": "mini",
      "round": ""
    },
    on: {
      "click": function($event) {
        _vm.selectItem('create')
      }
    }
  }, [_vm._v("\n          Create "), _c('i', {
    staticClass: "el-icon-circle-plus"
  })]) : _vm._e()], 1)]), _vm._v(" "), ((_vm.currentView || '').indexOf('campaign') !== -1) ? _c('div', {
    staticClass: "row footer"
  }, [_vm._v("stats reflect previous 7 days")]) : _vm._e(), _vm._v(" "), _c('ul', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "panel-items"
  }, [_c('virtual-scroll', {
    staticClass: "virtual-scroll-container",
    attrs: {
      "size": 187,
      "remain": 15,
      "bench": 20,
      "wtag": "ul"
    }
  }, [_vm._l((_vm.filteredItems), function(item) {
    return (_vm.filteredItems.length && !_vm.loading) ? _c('li', {
      key: item.id,
      class: _vm.panelClass(item),
      on: {
        "click": function($event) {
          _vm.selectItem(item.id)
        }
      }
    }, [_c('keep-alive', [_c(_vm.currentListItemView, {
      key: item.id,
      tag: "component",
      attrs: {
        "item": item
      }
    })], 1)], 1) : _vm._e()
  }), _vm._v(" "), ((!_vm.filteredItems || !_vm.filteredItems.length) && !_vm.loading) ? _c('li', {
    staticClass: "panel-item"
  }, [_c(_vm.currentListItemView, {
    tag: "component",
    attrs: {
      "item": false
    }
  })], 1) : _vm._e()], 2)], 1)]), _vm._v(" "), _c(_vm.currentView, {
    tag: "component",
    staticClass: "content-panel",
    attrs: {
      "item": _vm.selectedItem
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-icon-inner"
  }, [_c('div', {
    staticClass: "top-bar bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "mid-bar bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom-bar bar"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5999947a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/aroma.vue
// module id = kPrX
// module chunks = 1